<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_xxiii"><span class="small"><big>R</big>ACHMANINOFF<big>’</big>S <big>C</big>OMPLETE <big>S</big>ONGS</span></a></p><a id="page_xxiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_half1.vue?6797c266